import { AVATAR_SILHOUETTE_PATHS, AVATAR_SPINE_PATHS, SILHOUETTE_PART_ORDER } from '@/data/avatarSilhouettes';
import { AVATAR_VIEWBOX } from '@/data/avatarZones';
import { AVATAR_REGISTRY } from '@/data/avatarRegistry';
import type { Audience } from '@/types/domain';

interface Props {
  audience: Audience;
  /** Body outline is the same shape front or back (a flat A-pose silhouette doesn't reveal facing direction) — 'back' additionally draws the spine/shoulder-blade line, which is real surface detail that only exists on the back. */
  view?: 'front' | 'back';
  className?: string;
}

/**
 * Renders the base body silhouette for an audience — a coded SVG, not a
 * raster image, sharing AVATAR_VIEWBOX with AvatarMaskOverlay's region
 * masks so the two layers are always pixel-aligned.
 */
export function AvatarSilhouette({ audience, view = 'front', className = '' }: Props) {
  const paths = AVATAR_SILHOUETTE_PATHS[audience];

  return (
    <svg
      viewBox={AVATAR_VIEWBOX}
      role="img"
      aria-label={`${AVATAR_REGISTRY[audience].alt} (${view} view)`}
      className={`h-full w-full ${className}`}
    >
      <g fill="#9aa8bd" stroke="#7c8aa0" strokeWidth={0.4} strokeLinejoin="round">
        {SILHOUETTE_PART_ORDER.map((part) => (
          <path key={part} d={paths[part]} />
        ))}
      </g>
      {view === 'back' && (
        <path
          d={AVATAR_SPINE_PATHS[audience]}
          fill="none"
          stroke="#7c8aa0"
          strokeWidth={0.6}
          strokeLinecap="round"
          opacity={0.7}
        />
      )}
    </svg>
  );
}
